import { APIJobs } from '@platform/client';
import { EmailTabSection } from '../../components/EmailTabSection';

export const OrgEmailTabContent = ({ orgId }: { orgId: number }) => {
  const {
    data: emailData,
    isLoading,
    isError,
    isSuccess,
  } = APIJobs.useGetOrganizationEmailJobs(orgId);

  return (
    <EmailTabSection
      data={emailData}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      recordType='organization'
    />
  );
};
